// src/modules/Users/constants.ts
var ALL_USERS_ID = "usr-";
var USER_ROLES = {
	admin: "Admin",
	dispatch: "Dispatch",
	ops: "OPS",
	portal: "Portal",
	scheduling: "Scheduling"
};
var USER_ROLES_OPTIONS = [
	{
		label: "Admin",
		value: "admin"
	},
	{
		label: "OPS",
		value: "ops"
	},
	{
		label: "Portal",
		value: "portal"
	}
];
export { ALL_USERS_ID, USER_ROLES, USER_ROLES_OPTIONS };

//# sourceMappingURL=constants.js.map